if (!customElements.get('icraft-m-carousel')) {
  customElements.define('icraft-m-carousel', class extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      const signal = this.events.signal;
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.dots = [...this.querySelectorAll('[data-slide-to]')];
      this.pauseButton = this.querySelector('[data-carousel-pause]');
      this.index = 0;
      this.sequence = 0;
      this.rotationGeneration = 0;
      this.visible = false;
      this.hovered = false;
      this.focused = false;
      this.ready = false;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches || navigator.connection?.saveData === true;
      this.querySelector('.icraft-m-carousel-controls').hidden = false;
      this.updatePause();
      this.dots.forEach((button, index) => button.addEventListener('click', () => {
        this.paused = true;
        this.updatePause();
        this.stop();
        this.show(index);
      }, {signal}));
      this.pauseButton.addEventListener('click', () => {
        this.paused = !this.paused;
        this.updatePause();
        this.schedule();
      }, {signal});
      this.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse') { this.hovered = true; this.stop(); }
      }, {signal});
      this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, {signal});
      this.addEventListener('focusin', () => { this.focused = true; this.stop(); }, {signal});
      this.addEventListener('focusout', () => queueMicrotask(() => {
        this.focused = this.contains(document.activeElement);
        this.schedule();
      }), {signal});
      document.addEventListener('visibilitychange', () => this.schedule(), {signal});
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) this.paused = true;
        this.updatePause();
        this.schedule();
      }, {signal});
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.schedule();
      }, {threshold: 0.1});
      this.observer.observe(this);
      const ready = () => { this.ready = true; this.schedule(); };
      if (document.readyState === 'complete') ready();
      else window.addEventListener('load', ready, {once: true, signal});
    }
    updatePause() {
      this.pauseButton.setAttribute('aria-label', this.paused ? this.dataset.play : this.dataset.pause);
      this.pauseButton.querySelector('[data-pause-icon]').textContent = this.paused ? '▷' : 'Ⅱ';
    }
    canRotate() { return this.isConnected && this.ready && this.visible && !document.hidden && !this.paused && !this.hovered && !this.focused; }
    stop() {
      clearTimeout(this.timer);
      clearTimeout(this.idleTimer);
      if (this.idle != null && 'cancelIdleCallback' in window) cancelIdleCallback(this.idle);
      this.rotationGeneration++;
    }
    schedule() {
      this.stop();
      if (!this.canRotate()) return;
      this.timer = setTimeout(() => {
        const advance = async () => {
          if (!this.canRotate()) return;
          await this.show((this.index + 1) % this.slides.length, true);
          this.schedule();
        };
        if ('requestIdleCallback' in window) this.idle = requestIdleCallback(advance, {timeout: 2000});
        else this.idleTimer = setTimeout(advance, 0);
      }, 6500);
    }
    async show(index, automatic = false) {
      if (index === this.index) return;
      const sequence = ++this.sequence;
      const rotationGeneration = this.rotationGeneration;
      const slide = this.slides[index];
      if (slide.querySelector('template')) {
        const template = slide.querySelector('template');
        slide.append(template.content.cloneNode(true));
        template.remove();
      }
      const image = slide.querySelector('img');
      try { await image.decode(); } catch { return; }
      if (!this.isConnected || sequence !== this.sequence || (automatic && (rotationGeneration !== this.rotationGeneration || !this.canRotate()))) return;
      this.slides.forEach((item, i) => {
        item.classList.toggle('is-active', i === index);
        item.setAttribute('aria-hidden', String(i !== index));
      });
      this.dots.forEach((button, i) => {
        if (i === index) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
      this.index = index;
    }
    disconnectedCallback() { this.stop(); this.events?.abort(); this.observer?.disconnect(); }
  });
}
